import React from 'react';
import { Card, CardBodyText, CardContent } from '@saucelabs/ds-card';
import { amountSeparator } from '@saucelabs/sl-util-helpers/lib/numberHelpers';
import { Typography } from '@saucelabs/ds-typography/lib';

import { PRODUCT_API_TESTING, PRODUCT_MOBILE_QUALITY, PRODUCT_USAGE } from '../../../constants';
import { orderItemsToSubscriptionPreviews } from '../../../ducks/plans/utils';
import { PlanConfiguration } from '../../../records/PlanConfiguration';
import { OrderSummaryHeader, OrderSummarySeparator } from './OrderSummaryComponents';
import { OrderedPlans } from './OrderedPlans';

interface OrderSubtotalProps {
  subtotal: number;
}

export const OrderSubtotal: React.FC<OrderSubtotalProps> = ({ subtotal }) => (
  <div className="flex flex-row justify-between">
    <Typography
      className="text-high-emphasis mt-0 mb-0"
      disableSpacing
      variant="heading-4"
    >
      Subtotal
    </Typography>
    <div className="flex flex-col items-end">
      <Typography
        className="text-high-emphasis mt-0 mb-0"
        disableSpacing
        variant="heading-3"
      >
        {amountSeparator(subtotal)}
      </Typography>
      <Typography
        className="text-high-emphasis mt-0 mb-0"
        disableSpacing
        variant="body"
      >
        + taxes and fees
      </Typography>
    </div>
  </div>
);

interface OrderSummaryFromSelectionProps {
  allPlans: Array<Plan>;
  orderItems: Map<string, PlanConfiguration>;
}

export const OrderSummaryFromSelection: React.FC<OrderSummaryFromSelectionProps> = ({
  allPlans,
  orderItems,
}) => {
  const subscriptionPreviews = orderItemsToSubscriptionPreviews(orderItems, allPlans);
  const getPeriodRate = (planType: string) => subscriptionPreviews[planType].periodRate as number;

  const productTypes = orderItems.keySeq().toArray();
  const subtotal = productTypes
    .map((productType) => (getPeriodRate(productType)))
    .reduce((sum: number, current: number) => sum + current, 0);

  return (
    <Card className="w-full">
      <CardContent>
        <CardBodyText>
          <OrderSummaryHeader />
          <OrderSummarySeparator />
          <OrderedPlans
            allPlans={allPlans}
            orderItems={orderItems}
            subscriptionPreviews={subscriptionPreviews}
          />
          <OrderSubtotal subtotal={subtotal} />
        </CardBodyText>
      </CardContent>
    </Card>
  );
};
